import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useOfferingCategories = () => {
  const urlStr = `${getApiUrl()}/offering-category`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};
